"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sidePanelPage = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var classNames = require("classnames");
var Message_1 = require("@/pages/common/components/Message");
var Loading_1 = require("@/pages/common/components/Loading");
exports.mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state), { children: ownProps.children })); };
exports.mapDispatchToProps = function (dispatch) { return ({
    onLogoutClick: function () { return dispatch(LayoutAction_1.default.onLogoutClicked()); },
}); };
exports.sidePanelPage = function (props) {
    var userName = (props.user && props.user.id) ? (props.user.firstname ? props.user.firstname : props.user.email) : props.translate.guest;
    var renderSubItem = function (item, i) {
        var attr = {
            href: item.link
        };
        if (item.action === 'logout') {
            attr.href = '#';
            attr.onClick = function (e) { e.preventDefault(); props.onLogoutClick(); };
        }
        var isSelected = item.page === props.page;
        var classnames = classNames(['c-accordian__item', { 'c-accordian__item--alert': item.isAlert, 'c-accordian--selected': isSelected }]);
        return React.createElement("a", __assign({}, attr, { key: i, className: classnames }),
            React.createElement("span", { className: "c-accordian__text" },
                item.name,
                item.count ? " (" + item.count + ")" : ''));
    };
    var renderItem = function (props) { return function (item, i) {
        var attr = {
            href: item.link
        };
        if (item.action === 'logout') {
            attr.href = '#';
            attr.onClick = function (e) { e.preventDefault(); props.onLogoutClick(); };
        }
        return (React.createElement("div", { key: i, className: "c-accordian " + (item.page === props.page ? 'c-accordian--selected' : '') },
            React.createElement("a", __assign({}, attr, { className: "c-accordian__head" }),
                React.createElement("span", { className: "c-accordian__icon c-accordian__dot" }),
                React.createElement("span", { className: "c-accordian__text" }, item.name)),
            item.children ? (React.createElement("div", { className: "c-accordian__body" }, item.children.map(renderSubItem))) : null));
    }; };
    return (React.createElement(React.Fragment, null,
        React.createElement(Message_1.default, null),
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        React.createElement(Loading_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement("div", { className: "o-br" }),
        React.createElement("div", { className: "l-container l-container--r48 l-container--hide-mobile l-container--alignleft" },
            React.createElement("div", { className: "l-container__side" },
                React.createElement("div", { className: "c-accordian__title" },
                    React.createElement("span", { className: "c-accordian__icon" }),
                    React.createElement("span", { className: "c-accordian__text" }, userName)),
                props.side.items.map(renderItem(props))),
            React.createElement("div", { className: "l-container__main", style: { maxWidth: 'none' } }, props.children))));
};
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(exports.sidePanelPage);
